import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import createPartner from '@/API/Partner/createPartner';
import { transformFormDataForCreate } from '../utils/partnerFormUtils';

const useCreatePartner = (formData, onSuccess) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async () => {
            const couldNotCreateError =
                'Could not create Partner at this time. Please try again later.';
            try {
                // Transform the formData before sending to API
                const transformedData = transformFormDataForCreate(formData);
                const createPartnerResp = await createPartner(transformedData);
                return createPartnerResp.data;
            } catch (e) {
                toast.error(couldNotCreateError);
                throw e;
            }
        },
        onSuccess: (data) => {
            queryClient.invalidateQueries(['partners']);
            toast.success('Partner created successfully');
            
            // Call the onSuccess callback with the created partner data
            if (onSuccess) {
                onSuccess(data);
            }
        },
        onError: (error) => {
            console.error('Error creating partner:', error);
            
            if (error?.response?.data?.errors) {
                const errors = error.response.data.errors;
                const errorMessages = Object.values(errors)?.flat().join('\n');
                toast.error(errorMessages);
            }
        },
        staleTime: 0,
    });
};

export default useCreatePartner;
